import { ContextModalProps } from '@mantine/modals'
import AuditLogDetails from 'components/history/AuditLogDetails'
import { AuditLogTableItem } from 'types/audit'

type Props = {
  auditLog: AuditLogTableItem
}

export default function AuditLogDetailsModal({
  id,
  context: { closeModal },
  innerProps: { auditLog },
}: ContextModalProps<Props>) {
  return <AuditLogDetails closeModal={() => closeModal(id)} auditLog={auditLog} />
}
